// extracted by mini-css-extract-plugin
export default {"wrapper":"SetQuantity_wrapper__-uVMr"};